export default __webpack_public_path__ + "static/media/icon-error-1.8cee4c91.svg";